export default __webpack_public_path__ + "static/media/wow 1.ef129316.png";